<nz-layout>
  <nz-header>
    <span class="section-header">{{
      "Preview Summary" | translate
    }}</span></nz-header
  >
  <nz-content fxLayoutAlign="center">
    @if (isLoading) {
      <div fxLayout="row" fxLayoutAlign="center center">
        <nz-spin nzSimple></nz-spin>
      </div>
    }
    @if (!isLoading && data?.isEmpty) {
      <div fxLayout="row" fxLayoutAlign="center center">
        {{ "No records added" | translate }}!
      </div>
    }
    @if (!isLoading && !data?.isEmpty && !isInpatientView()) {
      <div fxLayout="row" fxLayoutAlign="start center" class="pd">
        <div fxLayout="col" fxFlex="15">{{ "Final Visit" | translate }}</div>
        <div fxLayout="col" fxFlex="85">
          <nz-switch
            [(ngModel)]="switchValue"
            (ngModelChange)="handleEndedValue($event)"
            class="pdd toggle"
          ></nz-switch>
        </div>
      </div>
    }
    @if (!isLoading && !data?.isEmpty) {
      <div fxLayout="row" fxLayoutAlign="start center" class="pd">
        <div fxLayout="col" fxFlex="15">
          {{ "Potential Diagnosis" | translate }}
        </div>
        <div fxLayout="col" fxFlex="85">
          <nz-select
            nzShowSearch
            nzAllowClear
            ngModel="pd"
            class="pdd"
            nzAllowClear
            [nzPlaceHolder]="'Choose Potential Diagnosis' | translate"
            [required]="true"
            [nzLoading]="isPdLoading"
            (ngModelChange)="setPD($event)"
            [ngModel]="pdValue"
            [ngClass]="{ 'ng-invalid': !pdValue }"
            [nzOptions]="pdList"
            nzNoAnimation
          >
            <!-- <ng-container *ngFor="let pdi of pdList">
              <nz-option nzLabel="{{pdi.name}}" nzValue="{{pdi.id}}"></nz-option>
            </ng-container> -->
          </nz-select>
        </div>
      </div>
    }
    @if (!isLoading && !data?.isEmpty) {
      <div fxLayout="row" fxLayoutAlign="start center" class="pd last-row">
        <div fxLayout="col" fxFlex="15">{{ "Notes" | translate }}</div>
        <div fxLayout="col" fxFlex="85">
          <textarea
            rows="2"
            nz-input
            [(ngModel)]="noteValue"
            class="nt"
            (ngModelChange)="setNote($event)"
          ></textarea>
        </div>
      </div>
    }

    <!--      VITAL SIGNS-->
    @if (data?.getAllVitalSigns?.length! > 0) {
      <app-reusable-reverse-table
        title="Vital Signs"
        [rowNames]="[
          'Temperature (°C)',
          'Respiratory Rate (bpm)',
          'Heart Rate (bpm)',
          'Systolic Blood Pressure (mm[Hg])',
          'Diastolic Blood Pressure (mm[Hg])',
          'Urine Output (ml/kg/h)',
          'SpO2 (%)',
        ]"
        [rowFields]="[
          'temperature',
          'respiratoryRate',
          'heartRate',
          'systolicBloodPressure',
          'diastolicBloodPressure',
          'urineOutput',
          'spO2',
        ]"
        colIdentifier="onSetDateTime"
        [data]="data?.getAllVitalSigns!"
        [isLoading]="isLoading"
        [isPreview]="true"
        [pagination]="false"
      />
      <!-- <app-reusable-table class="w-100" title="Vital Signs" [columns]="[
                        'Onset Date',
            'Temperature (°C)',
            'Respiratory Rate (bpm)',
            'Heart Rate (bpm)','Systolic Blood Pressure (mm[Hg])',
            'Diastolic Blood Pressure (mm[Hg])'
        ,'Urine Output (ml/kg/h)', 'SpO2 (%)']" [rowFields]="['onSetDateTime','temperature','respiratoryRate','heartRate','systolicBloodPressure',
            'diastolicBloodPressure',
            'urineOutput',
            'spO2']" [data]="data?.getAllVitalSigns" [isLoading]="isLoading" [isPreview]="true" [pagination]="false" /> -->
    }

    <!--      ARTERIAL BLOOD GASES-->
    @if (data?.getAllArterialBloodGasses?.length! > 0) {
      <app-reusable-table
        title="Arterial Blood Gases"
        [columns]="['Date & Time', 'pH', 'HCO3', 'PaCO2', 'PaO2', 'SaO2']"
        [rowFields]="['onSetDateTime', 'ph', 'hco3', 'paco2', 'pao2', 'sao2']"
        [data]="data?.getAllArterialBloodGasses"
        [isLoading]="isLoading"
        [isPreview]="true"
        [pagination]="false"
      />
    }

    <!--      GLASGOW COMA SCALE-->
    @if (data?.getAllGlasgow?.length! > 0) {
      <app-reusable-table
        title="Glasgow Coma Scale"
        [columns]="[
          'Date & Time',
          'Eye Opening',
          'Verbal Response',
          'Motor Response',
          'Score',
        ]"
        [rowFields]="[
          'onSetDateTime',
          'eyeOpeningName',
          'verbalResponseName',
          'motorResponseName',
          'totalScore',
        ]"
        [data]="data?.getAllGlasgow"
        [isLoading]="isLoading"
        [isPreview]="true"
        [pagination]="false"
      />
    }

    <!--      GLUCOSE-->
    @if (data?.getAllGlucose?.length! > 0) {
      <app-reusable-table
        title="Glucose"
        [columns]="['Date & Time', 'Glucose Measurement']"
        [rowFields]="['onSetDateTime', 'glucoseValue']"
        [data]="data?.getAllGlucose"
        [isLoading]="isLoading"
        [isPreview]="true"
        [pagination]="false"
      />
    }

    <!--      NUTRITION INTAKE-->
    @if (data?.getAllFoods?.length! > 0) {
      <app-reusable-table
        title="Nutrition Intake"
        [columns]="[
          'Date & Time',
          'Food Type',
          'Portion Size (gr)',
          'Portion Eaten (%)',
          'Description',
        ]"
        [rowFields]="[
          'onSetDateTime',
          'display',
          'portionSize',
          'portionEatenPercentage',
          'description',
        ]"
        [data]="data?.getAllFoods"
        [isLoading]="isLoading"
        [isPreview]="true"
        [pagination]="false"
      />
    }

    <!--      WEIGHT-->
    @if (data?.getAllWeights?.length! > 0) {
      <app-reusable-table
        title="Weight"
        [columns]="['Date', 'Weight (kg)', 'Description']"
        [rowFields]="['creationDate', 'weight', 'description']"
        [data]="data?.getAllWeights"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      NECK-->
    @if (data?.getAllNeckSizes?.length! > 0) {
      <app-reusable-table
        title="Neck"
        title="Neck Circumference"
        [columns]="['Date', 'Neck Circumference (cm)', 'Description']"
        [rowFields]="['creationDate', 'neckSize', 'description']"
        [data]="data?.getAllNeckSizes"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      ALLERGIES-->
    @if (
      data?.getAllAllergiesDto?.getAll?.length! > 0 ||
      data?.getAllAllergiesDto?.noKnown
    ) {
      <app-reusable-table
        title="Allergies"
        [columns]="[
          'Category',
          'Type',
          'Substance/Product',
          'Criticality',
          'Status',
        ]"
        [rowFields]="[
          'allergyCategory',
          'eventType',
          'allergy',
          'criticality',
          'allergyStatus',
        ]"
        [data]="data?.getAllAllergiesDto?.getAll"
        [dataGetList]="data?.getAllAllergiesDto"
        [pagination]="false"
        [expandComponent]="allergiesExpandComp"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      MEDICAL ALERT-->
    @if (data?.getAllMedicalAlerts?.length! > 0) {
      <app-reusable-table
        title="Medical Alerts"
        [columns]="['Description']"
        [rowFields]="['description']"
        [data]="data?.getAllMedicalAlerts"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      MEDICAL HISTORY-->
    @if (data?.getAllMedicalHistories?.length! > 0) {
      <app-reusable-table
        title="Medical History"
        [columns]="['Description']"
        [rowFields]="['description']"
        [data]="data?.getAllMedicalHistories"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      VACCINATION-->
    @if (data?.getAllVaccinations?.length! > 0) {
      <app-reusable-table
        title="Vaccinations"
        [columns]="[
          'Vaccine',
          'Disease Targeted',
          'Number Of Series Doses',
          'Next Date',
        ]"
        [rowFields]="[
          'vaccine',
          'diseaseTargeted',
          'numSeriesDoses',
          'nextDate',
        ]"
        [data]="data?.getAllVaccinations"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      RESOLVED PROBLEMS-->
    @if (data?.getAllResolvedProblemsDto?.length! > 0) {
      <app-reusable-table
        title="Resolved Problems"
        [columns]="[
          'Problem',
          'Diagnosis Assertion',
          'Resolution Circumstances',
          'End Date',
          'Status',
        ]"
        [rowFields]="[
          'problem',
          'diagnosisAssertion',
          'resolutionCircumstancesText',
          'endDate',
          'statusCode',
        ]"
        [data]="data?.getAllResolvedProblemsDto"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      CURRENT PROBLEMS-->
    @if (
      data?.getAllCurrentProblemsDto?.getAll?.length! > 0 ||
      data?.getAllCurrentProblemsDto?.noKnown
    ) {
      <app-reusable-table
        title="Current Problems"
        [columns]="[
          'Problem',
          'Diagnosis Assertion',
          'Resolution Circumstances',
          'Start Date',
          'Status',
        ]"
        [rowFields]="[
          'problem',
          'diagnosisAssertion',
          'resolutionCircumstancesText',
          'onSetDate',
          'statusCode',
        ]"
        [data]="data?.getAllCurrentProblemsDto?.getAll"
        [dataGetList]="data?.getAllCurrentProblemsDto"
        [pagination]="false"
        [expandComponent]="problemExpandComp"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      MEDICAL DEVICES-->
    @if (
      data?.getAllMedicalDevicesDto?.getAll?.length! > 0 ||
      data?.getAllMedicalDevicesDto?.noKnown
    ) {
      <app-reusable-table
        title="Devices and Implants"
        [columns]="['Medical Device', 'Onset Date', 'Removal Date', 'Action']"
        [rowFields]="[
          'medicalDevice',
          'onSetDate',
          'removalDate',
          'medicalDeviceAction',
        ]"
        [data]="data?.getAllMedicalDevicesDto?.getAll"
        [dataGetList]="data?.getAllMedicalDevicesDto"
        [pagination]="false"
        [expandComponent]="medicalDeviceExpandComp"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      PROCEDURES-->
    @if (
      data?.getAllProceduresDto?.getAll?.length! > 0 ||
      data?.getAllProceduresDto?.noKnown
    ) {
      <app-reusable-table
        title="Procedures"
        [columns]="['Procedure', 'BodySite', 'Date']"
        [rowFields]="['procedure', 'bodySite', 'date']"
        [data]="data?.getAllProceduresDto?.getAll"
        [dataGetList]="data?.getAllProceduresDto"
        [pagination]="false"
        [expandComponent]="procedureExpandComp"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      PREGNANCY HISTORY-->
    <ng-container>
      @if (data?.getAllPregnancyHistories?.length! > 0) {
        <app-reusable-table
          title="Pregnancy History"
          [columns]="['Status', 'Description', 'Outcome Date']"
          [rowFields]="['status', 'description', 'outcomeDate']"
          [data]="data?.getAllPregnancyHistories"
          [pagination]="false"
          [isPreview]="true"
          [isLoading]="isLoading"
        />
      }
    </ng-container>

    <!--      PREGNANCY OUTCOME-->
    <ng-container>
      @if (data?.getAllPregnancyOutcomes?.length! > 0) {
        <app-reusable-table
          title="Pregnancy Outcome"
          [columns]="['Outcome', 'Number of Children']"
          [rowFields]="['outcome', 'numberOfChildren']"
          [data]="data?.getAllPregnancyOutcomes"
          [pagination]="false"
          [isPreview]="true"
          [isLoading]="isLoading"
        />
      }
    </ng-container>

    <!--      PREGNANCY Status-->
    <ng-container>
      @if (data?.getAllPregnancyStatus?.length! > 0) {
        <app-reusable-table
          title="Pregnancy Status"
          [columns]="[
            'Date of Observation',
            'Status',
            'Pregnancy Estimation',
            'Pregnancy Estimation Date',
          ]"
          [rowFields]="[
            'dateOfObservation',
            'status',
            'pregnancyEstimated',
            'estimatedDate',
          ]"
          [data]="data?.getAllPregnancyStatus"
          [pagination]="false"
          [isPreview]="true"
          [isLoading]="isLoading"
        />
      }
    </ng-container>

    <!--      PREGNANCY Status-->
    <ng-container>
      @if (data?.getAllPregnancyStatus?.length! > 0) {
        <app-reusable-table
          title="Pregnancy Status"
          [columns]="[
            'Date of Observation',
            'Status',
            'Pregnancy Estimation',
            'Pregnancy Estimation Date',
          ]"
          [rowFields]="[
            'dateOfObservation',
            'status',
            'pregnancyEstimated',
            'estimatedDate',
          ]"
          [data]="data?.getAllPregnancyStatus"
          [pagination]="false"
          [isPreview]="true"
          [isLoading]="isLoading"
        />
      }
    </ng-container>

    <!--      Hysteroscopy Files -->
    @if (data?.getAllHysteroscopyFiles?.length! > 0) {
      <app-hysteroscopy-file
        [data]="data?.getAllHysteroscopyFiles"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      Current Medications-->
    <ng-container>
      @if (
        data?.getAllCurrentMedicationsDto?.getAll?.length! > 0 ||
        data?.getAllCurrentMedicationsDto?.noKnown
      ) {
        <div class="medication-table">
        <app-reusable-table
          title="Current Medication"
          [columns]="[
            'Period',
            'Product',
            'Package',
            'Unit',
            'Frequency',
            'Duration',
            'Scheduled Days',
          ]"
          [rowFields]="[
            'periodCombination',
            'productCombination',
            'packageCombination',
            'unitCombination',
            'frequencyCombination',
            'durationTreatmentCombination',
            'scheduledDaysCombination',
          ]"
          [data]="data?.getAllCurrentMedicationsDto?.getAll"
          [dataGetList]="data?.getAllCurrentMedicationsDto"
          [pagination]="false"
          [isPreview]="true"
          [isLoading]="isLoading"
        />
        </div>
      }
    </ng-container>

    <!--      Past Medications-->
    <ng-container>
      @if (data?.getAllPastMedicationsDto?.length! > 0) {
        <div class="medication-table">
        <app-reusable-table
          title="Past Medication"
          [columns]="[
            'Period',
            'Product',
            'Package',
            'Unit',
            'Frequency',
            'Duration',
            'Scheduled Days',
          ]"
          [rowFields]="[
            'periodCombination',
            'productCombination',
            'packageCombination',
            'unitCombination',
            'frequencyCombination',
            'durationTreatmentCombination',
            'scheduledDaysCombination',
          ]"
          [data]="data?.getAllPastMedicationsDto"
          [pagination]="false"
          [isPreview]="true"
          [isLoading]="isLoading"
          [isPreview]="true"
        />
        </div>
      }
    </ng-container>

    <!--      Social History -->
    <ng-container>
      @if (data?.getAllSocialHistories?.length! > 0) {
        <app-reusable-table
          title="Social History"
          [columns]="['Social History', 'Unit Amount', 'Timing Unit']"
          [rowFields]="['socialHistory', 'unitAmount', 'customTimingUnit']"
          [data]="data?.getAllSocialHistories"
          [pagination]="false"
          [isPreview]="true"
          [isLoading]="isLoading"
        />
      }
    </ng-container>

    <!--      Dietary Habits -->
    <ng-container>
      @if (data?.getAllDietaryHabits?.length! > 0) {
        <app-reusable-table
          title="Dietary Habits"
          [columns]="['Dietary Habits', 'Unit Amount', 'Timing Unit']"
          [rowFields]="['dietTypeName', 'unitAmount', 'customTimingUnit']"
          [data]="data?.getAllDietaryHabits"
          [pagination]="false"
          [isPreview]="true"
          [isLoading]="isLoading"
        />
      }
    </ng-container>

    <!-- SOCIAL HISTORY QUESTIONNAIRE -->
    <ng-container>
      @if (data?.getAllQuestionnaires?.length! > 0) {
        @for (section of questionnaireSections; track section.questionnaireId) {
          <app-reusable-table
            [title]="section.title"
            [columns]="[
              'Date & Time',
              'Total number of pages ',
              'Total number of questions',
              'Completion percentage',
              'Questions Completed',
              'Questions remaining',
              'Status',
            ]"
            [rowFields]="[
              'dateTime',
              'totalNumberOfPages',
              'totalNumberOfQuestions',
              'completionPercentage',
              'questionsCompleted',
              'questionsRemaining',
              'status',
            ]"
            [data]="section.rows"
            [pagination]="false"
            [isPreview]="true"
            [isLoading]="isLoading"
          />
        }
      }
    </ng-container>

    <!--      Travel History -->
    <ng-container>
      @if (data?.getAllTravelHistories?.length! > 0) {
        <app-reusable-table
          title="Travel History"
          [columns]="['Country', 'Departure Date', 'Arrival Date']"
          [rowFields]="['country', 'departureDate', 'arrivalDate']"
          [data]="data?.getAllTravelHistories"
          [pagination]="false"
          [isPreview]="true"
          [isLoading]="isLoading"
        />
      }
    </ng-container>

    <!--      Laboratory Files -->
    @if (data?.getAllLaboratoriesFiles?.length! > 0) {
      <app-laboratory-file
        [data]="data?.getAllLaboratoriesFiles"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      Laboratory Results -->
    <!-- <ng-container>
                                  <app-reusable-table *ngIf="data?.getAllLaboratoriesResults?.length! > 0" title="Laboratory Results"
                                    [columns]="['WBC (10⁹/L)','CRP (mg/L)','Platelet count, (10⁹/L)','Hemoglobin (g/dl)','Creatinine (µmol/L)']"
                                    [rowFields]="['wbc','crp','plateletCount','hemoglobin','creatinine']"
                                    [data]="data?.getAllLaboratoriesResults" [expandComponent]="laboratoryResultExpandComp"
                                    [pagination]="false" [isPreview]="true" [isLoading]="isLoading" />
                                  </ng-container> -->

    <!-- <ng-container *ngIf="data?.getAllLaboratoryData?.length! > 0">
            <app-reusable-reverse-table title="Laboratory Results" [rowNames]="['WBC (10⁹/L)',
        'Lymphocytes (10⁹/L)', 'Neutrophils (10⁹/L)', 'Platelet count (10⁹/L)', 'CRP (mg/L)', 'PT (sec)', 'INR', 'aPTT (sec)', 'Hemoglobin (g/dl)', 'Hematocrit (L/L)'
        ,'Creatinine (µmol/L)', 'Urea (mg/dL)']" [rowFields]="['wbc','lymphocytes','neutrophils','plateletCount', 'crp', 'pt',
        'inr', 'aptt', 'hemoglobin','hematocrit','creatinine', 'urea']" colIdentifier="date"
                                    [data]="data?.getAllLaboratoryData || []" [isLoading]="isLoading" [pagination]="false"
                                    [isPreview]="true" />
                                  </ng-container> -->

    <!--      Laboratory Results -->
    @if (
      data?.getAllLaboratoryData?.length! > 0 && data?.getLaboratoryDropdown
    ) {
      @for (package of data?.getLaboratoryDropdown; track package) {
        @if (data?.getAllLaboratoryData?.length! > 0) {
          <app-reusable-dynamic-table
            [title]="package.groupName || '' || ''"
            [groupId]="package.groupId || 0"
            [dropdownData]="package.items || []"
            colIdentifier="date"
            [isPreview]="true"
            [pagination]="false"
            endpoint="Laboratory"
            [data]="
              getLaboratoryData(data?.getAllLaboratoryData!, package.groupId!)
            "
          />
        }
      }
    }

    <!--      Imaging-->
    @if (data?.getAllImaging?.length! > 0) {
      <app-imaging-files
        [data]="data?.getAllImaging"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      ACTIVE CARE PLANS-->
    @if (data?.getAllActiveCarePlans?.length! > 0) {
      <app-reusable-table
        title="Active Care Plans"
        [columns]="[
          'Title',
          'Status',
          'Intent',
          'Category',
          'Period Start',
          'Period End',
          'Description',
        ]"
        [rowFields]="[
          'title',
          'statusDisplay',
          'intentDisplay',
          'categoryDisplay',
          'periodStart',
          'periodEnd',
          'description',
        ]"
        [data]="data?.getAllActiveCarePlans"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      PAST CARE PLANS-->
    @if (data?.getAllPastCarePlans?.length! > 0) {
      <app-reusable-table
        title="Past Care Plans"
        [columns]="[
          'Title',
          'Status',
          'Intent',
          'Category',
          'Period Start',
          'Period End',
          'Description',
        ]"
        [rowFields]="[
          'title',
          'statusDisplay',
          'intentDisplay',
          'categoryDisplay',
          'periodStart',
          'periodEnd',
          'description',
        ]"
        [data]="data?.getAllPastCarePlans"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      HEALTH CARE PLAN FALLBACK-->
    @if (
      data?.getAllCarePlans?.length! > 0 &&
      !data?.getAllActiveCarePlans?.length &&
      !data?.getAllPastCarePlans?.length
    ) {
      <app-reusable-table
        title="Health Care Plans"
        [columns]="[
          'Title',
          'Status',
          'Intent',
          'Category',
          'Period Start',
          'Period End',
          'Description',
        ]"
        [rowFields]="[
          'title',
          'statusDisplay',
          'intentDisplay',
          'categoryDisplay',
          'periodStart',
          'periodEnd',
          'description',
        ]"
        [data]="data?.getAllCarePlans"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      SERVICE REQUESTS-->
    @if (data?.getAllServiceRequests?.length! > 0) {
      <app-reusable-table
        title="Service Requests"
        [columns]="[
          'Status',
          'Intent',
          'Priority',
          'Category',
          'Procedure code',
          'Occurrence Start',
          'Occurrence End',
          'Description',
        ]"
        [rowFields]="[
          'statusDisplay',
          'intentDisplay',
          'priorityDisplay',
          'categoryDisplay',
          'procedureCodeDisplay',
          'occurrenceStart',
          'occurrenceEnd',
          'description',
        ]"
        [data]="data?.getAllServiceRequests"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      HEALTH CARE PLAN FILES-->
    @if (data?.getAllCarePlanFiles?.length! > 0) {
      <app-care-plan-file
        [data]="data?.getAllCarePlanFiles"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      CURRENT CARE TEAM -->
    @if (getCurrentCareTeamsForPreview().length > 0) {
      <app-reusable-table
        title="Current Care Teams"
        [columns]="[
          'Template',
          'Category',
          'Status',
          'Onset Date',
          'End Date'
        ]"
        [rowFields]="[
          'careTeamTemplateName',
          'careTeamCategoryDisplay',
          'careTeamStatusDisplay',
          'onSetDate',
          'endDate'
        ]"
        [data]="getCurrentCareTeamsForPreview()"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      PAST CARE TEAM -->
    @if (getPastCareTeamsForPreview().length > 0) {
      <app-reusable-table
        title="Past Care Teams"
        [columns]="[
          'Template',
          'Category',
          'Status',
          'Onset Date',
          'End Date'
        ]"
        [rowFields]="[
          'careTeamTemplateName',
          'careTeamCategoryDisplay',
          'careTeamStatusDisplay',
          'onSetDate',
          'endDate'
        ]"
        [data]="getPastCareTeamsForPreview()"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      3D-CT PARAMETERS -->
    @if (data?.getAllCtParameters?.length! > 0) {
      <app-reusable-table
        title="3D-CT Parameters"
        [columns]="[
          'Depth of Trachea',
          'Distance from Skin to Trache',
          'Distance from Cricothyroid to Carina',
          'Distance between Tracheal and Cartilages',
          'Anatomical Variations',
        ]"
        [rowFields]="[
          'depthOfTrachea',
          'distanceFromSkinToTrachea',
          'distanceFromCricothyroidToCarina',
          'distanceBetweenTrachealCartilages',
          'anatomicalVariations',
        ]"
        [data]="data?.getAllCtParameters"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      TUBE CHARACTERISTICS -->
    @if (data?.getAllTubeCharacteristics?.length! > 0) {
      <app-reusable-table
        title="Tube Characteristics"
        [columns]="[
          'Tube Size',
          'Tube Length',
          'Outer Diameter',
          'Inner Diameter',
          'Cuff Diameter',
          'Consistency of Tube',
          'Tube Type',
        ]"
        [rowFields]="[
          'tubeSize',
          'tubeLength',
          'outerDiameter',
          'innerDiameter',
          'cuffDiameter',
          'consistencyOfTube',
          'tubeType',
        ]"
        [data]="data?.getAllTubeCharacteristics"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      ETIOLOGIES -->
    @if (data?.getAllEtiologies?.length! > 0) {
      <app-reusable-table
        title="Patient's Etiologies"
        [columns]="['Condition']"
        [rowFields]="['etiologyDescription']"
        [data]="data?.getAllEtiologies"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!--      COMPLICATIONS -->
    @if (data?.getAllComplications?.length! > 0) {
      <app-reusable-table
        title="Patient's Complications"
        [columns]="['Condition']"
        [rowFields]="['complicationDescription']"
        [data]="data?.getAllComplications"
        [pagination]="false"
        [isPreview]="true"
        [isLoading]="isLoading"
      />
    }

    <!-- CAPNOGRAPHY -->
    <ng-container>
      @if (data?.getAllCapnographies?.length! > 0) {
        <app-reusable-reverse-table
          title="Capnography"
          [rowNames]="[
            'Positive end-expiratory pressure (PEEP)',
            'End Tidal CO2',
            'Fraction of inhaled oxygen (FiO2)',
            'Tidal Volume (Vt)',
            'Respiratory Rate (RR)',
            'Pressure of inhaled oxygen (Paw)',
          ]"
          [rowFields]="[
            'positiveEndExpiratoryPressure',
            'endTidal',
            'fractionInhaledOxygen',
            'tidalVolume',
            'respiratoryRate',
            'pressureInhaledOxygen',
          ]"
          colIdentifier="date"
          [data]="data?.getAllCapnographies || []"
          [isLoading]="isLoading"
          [pagination]="false"
          [isPreview]="true"
        />
      }
    </ng-container>

    <!-- COMORBIDITIES -->
    <ng-container>
      @if (data?.getAllComorbidities?.length! > 0) {
        <app-reusable-reverse-table
          title="Comorbidities"
          [rowNames]="[
            'No. of comorbidities',
            'Respiratory disease, n(%)',
            'Hypertension, n (%)',
            'COPD, n (%)',
            'Heart Disease, n(%)',
            'Diabetes mellitus type II, n (%)',
            'Malignancy, n (%)',
            'Stroke, n (%)',
            'Immunosuppression, n (%)',
          ]"
          [rowFields]="[
            'isNoComorbidities',
            'isRespiratoryDisease',
            'isHypertension',
            'isCopd',
            'isHeartDisease',
            'isDiabetesMellitus',
            'isMalignancy',
            'isStroke',
            'isImmunosuppression',
            'isNoComorbidities',
          ]"
          colIdentifier="date"
          [data]="data?.getAllComorbidities || []"
          [isLoading]="isLoading"
          [pagination]="false"
          [isPreview]="true"
        />
      }
    </ng-container>
  </nz-content>
</nz-layout>
